import { render, staticRenderFns } from "./listReception.vue?vue&type=template&id=3ae46fb5"
import script from "./listReception.js?vue&type=script&lang=js&external"
export * from "./listReception.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports